import { Alert, IconButton, Snackbar } from "@mui/material";
import React from "react";
import { Icon } from "../../components/Icon";

export const TLSnackbar = ({ open, onClose, type, variant, ...rest }) => {
  const handleClose = (event, reason) => {
    if (reason === "clickaway") return;
    onClose();
  };
  const action = (
    <IconButton
      size="small"
      aria-label="close"
      color="inherit"
      onClick={handleClose}
    >
      <Icon name={"Close"} />
    </IconButton>
  );

  return (
    <Snackbar
      open={open}
      autoHideDuration={6000}
      onClose={handleClose}
      action={action}
      anchorOrigin={{ vertical: "top", horizontal: "center" }}
      {...rest}
    >
      {type ? (
        <Alert elevation={6} severity={type} action={action} variant={variant}>
          {rest.message}
        </Alert>
      ) : null}
    </Snackbar>
  );
};
